/**
 * Shared rest-space value noise. Band-limited by construction: materials call
 * surfaceNoiseBL. The raw unfiltered field is internal and must not be sampled
 * from call sites.
 *
 * seedPhase is the pre-folded seed (e.g. uConcreteSeed * 19.19) so each
 * material keeps its existing lattice.
 *
 * Requires SURFACE_TRIPLANAR_GLSL first (surfaceOctaveFade).
 */
export const SURFACE_NOISE_GLSL = /* glsl */ `
float surfaceHash_(vec3 p, float seedPhase) {
  return fract(sin(dot(p, vec3(127.1, 311.7, 74.7)) + seedPhase) * 43758.5453);
}

float surfaceNoiseRawUnfiltered_(vec3 p, float seedPhase) {
  vec3 cell = floor(p);
  vec3 local = smoothstep(0.0, 1.0, fract(p));
  float n000 = surfaceHash_(cell + vec3(0.0, 0.0, 0.0), seedPhase);
  float n100 = surfaceHash_(cell + vec3(1.0, 0.0, 0.0), seedPhase);
  float n010 = surfaceHash_(cell + vec3(0.0, 1.0, 0.0), seedPhase);
  float n110 = surfaceHash_(cell + vec3(1.0, 1.0, 0.0), seedPhase);
  float n001 = surfaceHash_(cell + vec3(0.0, 0.0, 1.0), seedPhase);
  float n101 = surfaceHash_(cell + vec3(1.0, 0.0, 1.0), seedPhase);
  float n011 = surfaceHash_(cell + vec3(0.0, 1.0, 1.0), seedPhase);
  float n111 = surfaceHash_(cell + vec3(1.0, 1.0, 1.0), seedPhase);
  float x00 = mix(n000, n100, local.x);
  float x10 = mix(n010, n110, local.x);
  float x01 = mix(n001, n101, local.x);
  float x11 = mix(n011, n111, local.x);
  return mix(mix(x00, x10, local.y), mix(x01, x11, local.y), local.z);
}

float surfaceNoiseBL(vec3 p, float seedPhase, float wavelengthMeters, float fp) {
  return mix(0.5, surfaceNoiseRawUnfiltered_(p, seedPhase), surfaceOctaveFade(wavelengthMeters, fp));
}
`;
